export default function ProductApplicationSection() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            제품 라인
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            산업 현장의 안전과 편안함을 위한 전문 워크웨어
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <div className="bg-stone-50 rounded-2xl overflow-hidden shadow-lg">
            <div className="relative h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/cce0776869be28b9d1c4801fc9cc6ea9.jpg"
                alt="기능성 워크웨어"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">기능성 워크웨어</h3>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                건설, 제조, 물류 등 다양한 산업 현장에서 필요한 기능성과 내구성을 갖춘 전문 작업복입니다. 
                에어로젤 코팅 섬유를 적용하여 극한의 환경에서도 최적의 작업 환경을 제공합니다.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  사계절 착용 가능한 온도 조절 기능
                </li>
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  내구성 강화 설계로 장기간 사용
                </li>
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  인체공학적 패턴으로 편안한 착용감
                </li>
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  다양한 포켓과 수납 공간
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-stone-50 rounded-2xl overflow-hidden shadow-lg">
            <div className="relative h-80">
              <img
                src="https://readdy.ai/api/search-image?query=industrial%20protective%20clothing%20safety%20workwear%20high%20visibility%20reflective%20gear%20factory%20worker%20wearing%20professional%20protection%20equipment%20manufacturing%20facility%20work%20environment%20professional%20photography&width=700&height=500&seq=daygreen-protective-1&orientation=landscape"
                alt="산업용 보호 의류"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">산업용 보호 의류</h3>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                위험한 작업 환경에서 작업자의 안전을 최우선으로 고려한 전문 보호 의류입니다. 
                각종 산업 안전 규격을 충족하며 최고 수준의 보호 성능을 제공합니다.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  난연 소재로 화재 위험 방지
                </li>
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  고가시성 반사 소재 적용
                </li>
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  화학물질 및 오염 물질 차단
                </li>
                <li className="flex items-center gap-3 text-base text-gray-600">
                  <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                  산업 안전 규격 인증 완료
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-stone-50 rounded-2xl p-10 text-center">
          <h3 className="text-3xl font-bold text-gray-800 mb-4">맞춤 제작 서비스</h3>
          <p className="text-base text-gray-600 max-w-2xl mx-auto mb-8 leading-relaxed">
            귀사의 작업 환경과 요구사항에 맞춘 맞춤형 워크웨어를 제작해드립니다. 
            소재 선택부터 디자인, 기능 추가까지 전문가와 함께 최적의 솔루션을 찾아드립니다.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button className="px-8 py-3 bg-gray-800 text-white rounded-full font-medium hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer">
              제품 문의하기
            </button>
            <button className="px-8 py-3 bg-white text-gray-800 rounded-full font-medium hover:bg-gray-50 transition-colors border border-gray-300 whitespace-nowrap cursor-pointer">
              카탈로그 다운로드
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}